export const messages = {
  namespaced: true,
  state: {
    value: null,
  },
}
